import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import InputField from "./inputField";
import PsContext from "../../../context";
import { capitalizeFirst, upperCase } from "../../../utils";

const BedQualificationDetails = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [basic, setBaisc] = useState([]);
  const [marks, setMarks] = useState([]);
  const [preference, setPreference] = useState([]);

  const field = (fieldName) => {
    try {
      if (props.data && props.data[0][fieldName])
        return props.data[0][fieldName];
    } catch (er) {}
  };

  console.log("data", props.data);

  const monthNames = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  // Safe access to pass_month with null checks
  const formattedMonth =
    props.data && props.data[0] && props.data[0].pass_month
      ? monthNames[parseInt(props.data[0].pass_month) - 1]
      : "";

  // Safe access to data items
  const getDataValue = (index, fieldName) => {
    return props.data && props.data[index] ? props.data[index][fieldName] : "";
  };

  return (
    <>
      <div className="table-responsive mt-3">
        <table className="table table-sm table-bordered hsc-mark-table">
          <thead>
            <tr className="bg-light">
              <th>Subject Name</th>
              <th width="60">Scored</th>
              <th width="60">Maximum Marks</th>
              <th width="130">Month & Year of passing</th>
              <th>Register No</th>
              <th>No.of Attempts</th>
            </tr>
          </thead>

          <tbody>
            {props.data &&
              props.data
                .filter((item) => {
                  return (
                    item &&
                    item.subject_name !== "null" &&
                    item.subject_name !== undefined &&
                    item.subject_name !== "" &&
                    String(item.subject_name).trim().length > 0
                  );
                })
                .map((item, i) => (
                  <tr key={i}>
                    <td>{item.subject_name}</td>
                    <td align="right">{item.mark_scored || ""}</td>
                    <td align="right">{item.mark_maximum || ""}</td>
                    <td align="center">
                      {item.pass_month || ""} / {item.pass_year || ""}
                    </td>
                    <td align="center">{item.register_no || ""}</td>
                    <td align="center">{item.no_of_attempts || ""}</td>
                  </tr>
                ))}
            <tr>
              <td>Total</td>
              <td align="right" className="bg-light fw-bold">
                {field("scored_total") || ""}
              </td>
              <td align="right" className="bg-light fw-bold">
                {field("max_total") || ""}
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <InputField
        label="College Previously studied"
        value={capitalizeFirst(getDataValue(0, "college_name"))}
      />

      <InputField
        label="Place of the College Previously studied"
        value={upperCase(getDataValue(0, "college_place"))}
      />

      <InputField
        label="Name of the University"
        value={getDataValue(0, "university_name")}
      />

      <InputField
        label="Studied Degree in UG"
        value={getDataValue(0, "studied_degree")}
      />

      <InputField
        label="Studied Major in UG"
        value={getDataValue(0, "studied_ug")}
      />

      <InputField
        label="Percentage of U.G Degree Course Major"
        value={getDataValue(0, "percentage_major")}
      />

      <InputField
        label="Percentage of U.G Degree Course Allied"
        value={getDataValue(0, "percentage_allied")}
      />

      <InputField
        label="Major subject in the higher Qualification"
        value={getDataValue(0, "major_subqualification")}
      />

      <InputField label="Month of Passing" value={formattedMonth} />

      <InputField label="Month of Year" value={getDataValue(0, "pass_year")} />
      {/* 
      <InputField 
        label="Medium of Instruction" 
        value={getDataValue(0, 'study_medium')} 
      /> */}

      <InputField
        label="Medium opted to write B.Ed. Examination"
        value={getDataValue(0, "opted_medium")}
      />
    </>
  );
};

export default BedQualificationDetails;
